<template>
    <div class="ah-file-item">
        <div class="file">
            <div v-if="['jpeg', 'jpg', 'png'].includes(getFileExtByUrl(url))" class="img-rect">
                <el-image style="width: 100%" :src="url" :previewSrcList="[url]" v-if="url"></el-image>
            </div>
            <div v-else-if="url" class="file-rect">
                <ahFileIcon ext="pdf" :url="url" />
            </div>
            <div v-else class="no-file-rect">
                <span style="color: #aaa; cursor: default;">未上傳</span>
            </div>
        </div>

        <el-button v-if="editable" size="small" class="edit-btn" @click="handleFileEditBtnClick">
            更換
        </el-button>
    </div>
</template>
<script>
import ahFileIcon from '@/components/ui/ahFileIcon.vue';

export default {
    name: 'ah-file-item',
    components: { ahFileIcon },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        url: {
            type: String,
            default: null,
        },
    },
    methods: {
        handleFileEditBtnClick() {
            this.$emit('edit', this.url);
        },
        handleFileDeleteBtnClick() {
            this.$emit('delete', this.url);
        },
        getFileExtByUrl(url) {
            if (url) {
                return url
                    .split('.')
                    .pop()
                    .toLowerCase();
            }
            return null;
        },
    },
};
</script>
<style lang="scss">
.ah-file-item {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 5px 10px;
    border-radius: 8px;
    border: 2px solid #eee;

    > .file {
        // width: 100%;

        > .img-rect,
        > .file-rect,
        > .no-file-rect {
            margin: auto;
            width: 250px;
            height: 165px;
            border: 2px solid #ddd;
            background-color: #fff;
            border-radius: 6px;
            transition: border-color 0.2s;

            &:hover {
                border: 2px solid #bbb;
            }

            .el-image {
                img {
                    width: calc(250px - 6px);
                    height: calc(165px - 6px);
                    object-fit: contain;
                }
            }

            .ah-file-icon {
                margin-top: 38px;
            }
        }
        > .no-file-rect {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    > .edit-btn {
        margin-left: 10px;
        height: fit-content;
    }
}
</style>
